class CollapsibleTab extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    disconnectedCallback() {
        this.destroy();
    }
    init() {
        "true" === this.dataset.destroy ||
            (this.setDefaultData(),
                this.attachEvents(),
                "true" === this.getAttribute("open")
                    ? ((this.selected = !0), this.classList.add(this.expandedClass), this.setExpandedAria())
                    : ((this.content.style.height = this.collapsedHeight), this.classList.add(this.collapsedClass), this.setCollapsedAria()),
                this.content.removeAttribute("hidden"));
    }
    transitionendEventName() {
        let e,
            t = document.createElement("div"),
            i = { transition: "transitionend", OTransition: "otransitionend", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
        for (e in i) if (i.hasOwnProperty(e) && void 0 !== t.style[e]) return i[e];
    }
    expand() {
        const e = ((t) => {
            t.target === this.content &&
                (this.content.removeEventListener(this.transitionendevent, e),
                    this.isOpen &&
                    requestAnimationFrame(() => {
                        (this.content.style.transition = "0"),
                            (this.content.style.height = "auto"),
                            requestAnimationFrame(() => {
                                (this.content.style.height = null), (this.content.style.transition = null), this.setExpandedAria(), this.classList.add(this.expandedClass), this.trySetTabIndex(this.content, 0), this.fire("tabOpened");
                            });
                    }));
        }).bind(this);
        this.content.addEventListener(this.transitionendevent, e), (this.isOpen = !0), this.classList.remove(this.collapsedClass), (this.content.style.height = this.content.scrollHeight + "px");
    }
    collapse() {
        const e = ((t) => {
            t.target === this.content &&
                (this.content.removeEventListener(this.transitionendevent, e), this.isOpen || (this.fire("elementClosed"), this.setCollapsedAria(), this.classList.add(this.collapsedClass), this.trySetTabIndex(this.content, -1)));
        }).bind(this);
        this.content.addEventListener(this.transitionendevent, e),
            (this.isOpen = !1),
            this.classList.remove(this.expandedClass),
            requestAnimationFrame(() => {
                (this.content.style.transition = "0"),
                    (this.content.style.height = this.content.scrollHeight + "px"),
                    requestAnimationFrame(() => {
                        (this.content.style.transition = null), (this.content.style.height = this.collapsedHeight);
                    });
            });
    }
    open() {
        (this.selected = !0), this.fire("elementSelected"), this.expand(), this.setAttribute("open", !0);
    }
    close() {
        (this.selected = !1), this.fire("elementUnselected"), this.collapse(), this.removeAttribute("open");
    }
    toggle(e) {
        if ((e.preventDefault(), this.selected)) this.close();
        else if ((this.open(), this.oneAtATime)) {
            const e = document.querySelectorAll("collapsible-tab"),
                t = this.closest("[data-first-level]");
            e.length &&
                e.forEach((e) => {
                    e !== this && e.selected && t !== e && e.close();
                });
        }
    }
    trySetTabIndex(e, t) {
        const i = e.querySelectorAll(this.defaultElements);
        i &&
            i.forEach((e) => {
                e.setAttribute("tabindex", t);
            });
    }
    setExpandedAria() {
        this.trigger.setAttribute("aria-expanded", "true"), this.content.setAttribute("aria-hidden", "false");
    }
    setCollapsedAria(e) {
        this.trigger.setAttribute("aria-expanded", "false"), this.content.setAttribute("aria-hidden", "true");
    }
    attachEvents() {
        this.trigger.addEventListener("click", (e) => this.toggle(e));
    }
    setDefaultData() {
        (this.events = { elementSelected: [], tabOpened: [], elementUnselected: [], elementClosed: [] }),
            (this.transitionendevent = this.transitionendEventName()),
            (this.expandedClass = "is-expanded"),
            (this.collapsedClass = "is-collapsed"),
            (this.trigger = this.querySelector("[data-trigger]")),
            (this.content = this.querySelector("[data-content]")),
            (this.collapsedHeight = "0px"),
            (this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"]),
            (this.oneAtATime = !0),
            this.dataset.oneOpen && (this.oneAtATime = "true" === this.dataset.oneOpen);
    }
    fire(e) {
        let t = this.events[e];
        if (t) for (let e = 0; e < t.length; e++) t[e](this);
    }
    on(e, t) {
        this.events[e] && this.events[e].push(t);
    }
    destroy() {
        this.trigger.removeEventListener("click", (e) => this.toggle(e)),
            this.content.removeAttribute("aria-hidden"),
            (this.content.style.height = "auto"),
            this.classList.remove(this.expandedClass, this.collapsedClass),
            this.removeAttribute("open");
    }
}
if (!customElements.get("collapsible-tab")) {
    customElements.define("collapsible-tab", CollapsibleTab);
}
